export type KeyDevelopmentType =
  | 'Valuation'
  | 'Future'
  | 'Past'
  | 'Financial'
  | 'Dividend'
  | 'Strategy'
  | 'Management'
  | 'Ownership'
  | 'Other';

export const KEY_DEVELOPMENT_TYPE: Record<number | string, KeyDevelopmentType> =
  {
    1: 'Strategy',
    3: 'Strategy',
    5: 'Ownership',
    7: 'Financial',
    11: 'Financial',
    12: 'Financial',
    16: 'Management',
    21: 'Strategy',
    22: 'Strategy',
    23: 'Strategy',
    24: 'Other',
    25: 'Other',
    26: 'Future',
    27: 'Future',
    28: 'Past',
    29: 'Future',
    31: 'Strategy',
    32: 'Strategy',
    36: 'Strategy',
    41: 'Strategy',
    42: 'Financial',
    43: 'Past',
    44: 'Strategy',
    45: 'Dividend',
    46: 'Dividend',
    47: 'Dividend',
    48: 'Past',
    49: 'Future',
    50: 'Future',
    51: 'Future',
    52: 'Strategy',
    53: 'Dividend',
    54: 'Dividend',
    55: 'Past',
    56: 'Strategy',
    57: 'Other',
    58: 'Strategy',
    59: 'Financial',
    61: 'Past',
    62: 'Management',
    63: 'Strategy',
    64: 'Dividend',
    65: 'Strategy',
    68: 'Valuation',
    69: 'Valuation',
    70: 'Valuation',
    71: 'Valuation',
    72: 'Valuation',
    73: 'Past',
    74: 'Financial',
    75: 'Valuation',
    76: 'Strategy',
    77: 'Strategy',
    78: 'Strategy',
    79: 'Strategy',
    80: 'Strategy',
    81: 'Strategy',
    82: 'Strategy',
    83: 'Ownership',
    85: 'Ownership',
    86: 'Ownership',
    87: 'Ownership',
    88: 'Ownership',
    89: 'Financial',
    90: 'Financial',
    91: 'Financial',
    92: 'Ownership',
    93: 'Financial',
    94: 'Dividend',
    95: 'Valuation',
    97: 'Strategy',
    99: 'Other',
    100: 'Dividend',
    101: 'Management',
    102: 'Management',
    112: 'Strategy',
    117: 'Dividend',
    134: 'Ownership',
    135: 'Financial',
    136: 'Financial',
    137: 'Strategy',
    138: 'Past',
    139: 'Past',
    140: 'Past',
    142: 'Strategy',
    144: 'Past',
    149: 'Future',
    150: 'Financial',
    151: 'Strategy',
    152: 'Strategy',
    153: 'Financial',
    154: 'Financial',
    155: 'Financial',
    156: 'Ownership',
    157: 'Ownership',
    160: 'Ownership',
    163: 'Ownership',
    164: 'Ownership',
    172: 'Ownership',
    177: 'Ownership',
    187: 'Ownership',
    192: 'Future',
    194: 'Strategy',
    205: 'Other',
    206: 'Other',
    207: 'Other',
    213: 'Dividend',
    214: 'Dividend',
    215: 'Dividend',
    218: 'Management',
    219: 'Past',
    220: 'Management',
    221: 'Past',
    222: 'Past',
    223: 'Ownership',
    224: 'Future',
    225: 'Future',
    226: 'Past',
    230: 'Strategy',
    231: 'Strategy',
    232: 'Strategy',
    233: 'Strategy',
    234: 'Strategy',
    1001: 'Management',
    1002: 'Management',
    //briefs
    HasMajorEstimateRevision: 'Future',
    HasPriceTargetChanged: 'Future',
    HasBreakevenDateChange: 'Future',
    BuyingOpportunity: 'Future',
    HasReportedEarnings: 'Future',
    //articles
    'Analyst estimates earnings update': 'Future',
    'Analyst estimates major revisions': 'Future',
    Breakeven: 'Future',
    'Earnings report': 'Future',
    'Intrinsic value': 'Future',
    'PE Beginner': 'Future',
    'ROE Beginner': 'Future',
    timing: 'Future',
  };
